export const inspectionCategoryResultsFields = [
  'id',
  {
    inspectionCategory: ['id', 'name'],
  },
  {
    payload: [
      'status',
      {
        tireTreadMeasurements: [
          'frontLeft',
          'frontRight',
          'backLeft',
          'backRight',
        ],
      },
      {
        tireTreadMeasurementsMiddle: [
          'frontLeft',
          'frontRight',
          'backLeft',
          'backRight',
        ],
      },
      {
        tireTreadMeasurementsOuter: [
          'frontLeft',
          'frontRight',
          'backLeft',
          'backRight',
        ],
      },
      {
        tirePressureMeasurements: [
          'frontLeft',
          'frontRight',
          'backLeft',
          'backRight',
          'complimentaryService',
        ],
      },
      {
        brakePadMeasurements: [
          'frontLeft',
          'frontRight',
          'backLeft',
          'backRight',
        ],
      },
      {
        batteryReadings: ['coldCrankAmps', 'ratedColdCrankAmps', 'voltage'],
      },
    ],
  },
];

export const inspectionFields = [
  'id',
  'repairRequestId',
  'repairRefNum',
  'consumerId',
  'carId',
  'completedAt',
  'modifiedBy',
  'performedById',
  {
    inspectionType: [
      'id',
      'name',
      'type',
      {
        inspectionTypeCategories: [
          'id',
          {
            category: ['id', 'name'],
          },
          {
            components: [
              'id',
              'name',
              {
                inspectionRsRepairs: ['id', 'repairId', 'name'],
              },
              {
                inspectionSymptoms: ['id', 'name'],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    inspectionCategoryResults: inspectionCategoryResultsFields,
  },
  {
    inspectionResults: [
      'id',
      'status',
      'images',
      'suggestedRepairId',
      'repairId',
      'repairName',
      {
        payload: ['additionalInformation', 'customServiceRequest'],
      },
      {
        inspectionSymptoms: ['id', 'name'],
      },
      {
        inspectionComponent: [
          'id',
          'name',
          {
            inspectionCategories: ['id', 'name'],
          },
          {
            inspectionRsRepairs: ['id', 'name', 'repairId'],
          },
          {
            inspectionSymptoms: ['id', 'name'],
          },
        ],
      },
      {
        inspectionRsRepair: ['id', 'name', 'repairId', 'inspectionCategoryId'],
      },
      {
        inspectionCategory: ['id', 'name'],
      },
    ],
  },
];

export const checklistFields = [
  'id',
  'repairRequestId',
  'repairRefNum',
  'consumerId',
  'carId',
  'completedAt',
  'modifiedBy',
  'performedById',
  'images',
  {
    checklistAnswers: [
      'id',
      'inspectionId',
      'checklistQuestionId',
      'answer',
      'notes',
    ],
  },
  {
    inspectionType: [
      'id',
      'name',
      'type',
      {
        checklistAnswerLabels: ['needsWorkLabel', 'okLabel'],
      },
      {
        inspectionTypeCategories: [
          'id',
          {
            category: [
              'id',
              'name',
              {
                checklistQuestions: [
                  'id',
                  'inspectionCategoryId',
                  'question',
                  'summaryQuestion',
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];
